export enum WillCountry {
    australia = 'Australia',
    britishVirginIslands = 'BritishVirginIslands',
    canada = 'Canada',
    caymanIslands = 'CaymanIslands',
    france = 'France',
    germany = 'Germany',
    gibraltar = 'Gibraltar',
    guernsey = 'Guernsey',
    hongKong = 'HongKong',
    india = 'India',
    ireland = 'Ireland',
    isleOfMan = 'IsleOfMan',
    israel = 'Israel',
    italy = 'Italy',
    japan = 'Japan',
    jersey = 'Jersey',
    luxembourg = 'Luxembourg',
    malaysia = 'Malaysia',
    // mainlandChina = "Mainland China",
    newZealand = 'NewZealand',
    philippines = 'Philippines',
    singapore = 'Singapore',
    southAfrica = 'SouthAfrica',
    // sweden = 'Sweden',
    switzerland = 'Switzerland',
    taiwan = 'Taiwan',
    thailand = 'Thailand',
    unitedKingdom = 'UnitedKingdom',
    unitedStates = 'UnitedStatesOfAmerica',
    vietnam = 'Vietnam',
}

export interface WillCountryMetadata {
    isoCountryCode: string;
    topologyId: string;
    markerCoordinates?: [number, number];
}

// ISO 3166-1 numeric identifiers match the locally bundled Natural Earth
// topology. Markers keep tiny jurisdictions usable at the map's fixed size.
export const WILL_COUNTRY_METADATA: Record<WillCountry, WillCountryMetadata> = {
    [WillCountry.australia]: { isoCountryCode: 'AU', topologyId: '036' },
    [WillCountry.britishVirginIslands]: { isoCountryCode: 'VG', topologyId: '092', markerCoordinates: [-64.64, 18.42] },
    [WillCountry.canada]: { isoCountryCode: 'CA', topologyId: '124' },
    [WillCountry.caymanIslands]: { isoCountryCode: 'KY', topologyId: '136', markerCoordinates: [-81.25, 19.31] },
    [WillCountry.france]: { isoCountryCode: 'FR', topologyId: '250' },
    [WillCountry.germany]: { isoCountryCode: 'DE', topologyId: '276' },
    [WillCountry.gibraltar]: { isoCountryCode: 'GI', topologyId: '292', markerCoordinates: [-5.35, 36.14] },
    [WillCountry.guernsey]: { isoCountryCode: 'GG', topologyId: '831', markerCoordinates: [-2.58, 49.46] },
    [WillCountry.hongKong]: { isoCountryCode: 'HK', topologyId: '344', markerCoordinates: [114.17, 22.3] },
    [WillCountry.india]: { isoCountryCode: 'IN', topologyId: '356' },
    [WillCountry.ireland]: { isoCountryCode: 'IE', topologyId: '372' },
    [WillCountry.isleOfMan]: { isoCountryCode: 'IM', topologyId: '833', markerCoordinates: [-4.55, 54.24] },
    [WillCountry.israel]: { isoCountryCode: 'IL', topologyId: '376' },
    [WillCountry.italy]: { isoCountryCode: 'IT', topologyId: '380' },
    [WillCountry.japan]: { isoCountryCode: 'JP', topologyId: '392' },
    [WillCountry.jersey]: { isoCountryCode: 'JE', topologyId: '832', markerCoordinates: [-2.13, 49.21] },
    [WillCountry.luxembourg]: { isoCountryCode: 'LU', topologyId: '442', markerCoordinates: [6.13, 49.82] },
    [WillCountry.malaysia]: { isoCountryCode: 'MY', topologyId: '458' },
    [WillCountry.newZealand]: { isoCountryCode: 'NZ', topologyId: '554' },
    [WillCountry.philippines]: { isoCountryCode: 'PH', topologyId: '608' },
    [WillCountry.singapore]: { isoCountryCode: 'SG', topologyId: '702', markerCoordinates: [103.82, 1.35] },
    [WillCountry.southAfrica]: { isoCountryCode: 'ZA', topologyId: '710' },
    [WillCountry.switzerland]: { isoCountryCode: 'CH', topologyId: '756' },
    [WillCountry.taiwan]: { isoCountryCode: 'TW', topologyId: '158' },
    [WillCountry.thailand]: { isoCountryCode: 'TH', topologyId: '764' },
    [WillCountry.unitedKingdom]: { isoCountryCode: 'GB', topologyId: '826' },
    [WillCountry.unitedStates]: { isoCountryCode: 'US', topologyId: '840' },
    [WillCountry.vietnam]: { isoCountryCode: 'VN', topologyId: '704' },
};

export const PLATFORM_COUNTRIES: WillCountry[] = [
    WillCountry.australia,
    WillCountry.hongKong,
    WillCountry.singapore,
    WillCountry.malaysia,
    WillCountry.unitedKingdom,
    WillCountry.unitedStates,
];

export const OFF_PLATFORM_COUNTRIES: WillCountry[] = Object.values(WillCountry).filter(
    country => country !== WillCountry.thailand && country !== WillCountry.vietnam && !PLATFORM_COUNTRIES.includes(country)
);
